import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { I18nService } from '../../core/services/i18n.service';

export function expiryDateValidator(i18nService: I18nService): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const value = control.value.replace(/\D/g, '');
    
    // Verificar se tem 6 dígitos
    if (value.length !== 6) {
      return { 
        invalidDate: { 
          message: i18nService.instant('validators.expiryDate.invalidDate')
        } 
      };
    }

    const month = parseInt(value.substring(0, 2), 10);
    const year = parseInt(value.substring(2, 6), 10);

    // Verificar se o mês é válido
    if (month < 1 || month > 12) {
      return { 
        invalidDate: { 
          message: i18nService.instant('validators.expiryDate.invalidDate')
        } 
      };
    }

    // Verificar se a data não expirou
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;

    if (year < currentYear || (year === currentYear && month < currentMonth)) {
      return { 
        invalidDate: { 
          message: i18nService.instant('validators.expiryDate.invalidDate')
        } 
      };
    }

    return null;
  };
}
